import { Enrollee } from "pmt-types/src/models/Enrollee.ts";
import { PagedApiData } from "pmt-types/src/utils/PagedApiData.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetEnrolleesForProjectId = (
  sourceId: Maybe<string>,
  projectId: Maybe<string>,
) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetProjectEnrollees, projectId],
    async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/enrollees`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query project enrollees");
      }

      const apiData = (await response.json()) as PagedApiData<Enrollee>;

      return apiData?.data ?? [];
    },
    {
      enabled: sourceId != null && projectId != null && projectId !== "new",
      onError: (error) => {
        console.error("Failed to get enrollees for project", error, sourceId);
      },
    },
  );
};
